// extracted by mini-css-extract-plugin
export default {"box":"xDyTggQIkH6cNYVNExu3"};